<template>
  <hic-list-page title="科室房间" :entities="entities" :condition="condition" @load="page" :loading="meta.loading" keyword-placeholder="请输入名称或编码">
    <template slot="buttons">
      <el-button @click.native="create" type="primary" size="small" v-if="permission.masterdata_dept_edit"> <i class="el-icon-plus"></i> 新建 </el-button>
      </template>
      <el-table-column fixed="left" label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button  v-if="permission.masterdata_dept_edit" size="mini" type="primary" icon="el-icon-edit" circle plain @click="handleEdit(scope.row)" style="margin-right: 8px"></el-button>
            <el-popconfirm  v-if="permission.masterdata_dept_edit" confirmButtonText="确认" cancelButtonText="取消" icon="el-icon-info" iconColor="red" title="确认删除这条应用？" @confirm="handleDelete(scope.row)">
              <el-button size="mini" type="danger" icon="el-icon-delete" circle plain slot="reference"></el-button>
            </el-popconfirm>
          </template>
        </el-table-column>

        <el-table-column fixed="left" prop="name" label="名称"  sortable="custom">
          <template slot-scope="{ row }">
            <b>{{ row.name }}</b>
          </template>
        </el-table-column>

        <el-table-column prop="code" label="编码"  sortable="code"></el-table-column>
   
        <el-table-column prop="deptCode" label="科室编码" sortable="deptCode" :filters="dict.Dept" :filter-multiple="false" column-key="deptCode">
          <template slot-scope="{row}">
            {{row.deptCode | dictText("Dept")}}
          </template>
        </el-table-column>

        <el-table-column prop="memo" label="备注"></el-table-column>

        <apply-editor v-model="entity" :visible.sync="showEditor" @ok="page" />
  </hic-list-page>


</template>

<script>
import api from "./api.js";
import store from "@/common/store";
// import cfg from "@/common/cfg"
import { mapGetters } from "sw-hic";
export default {
  beforeRouteEnter(to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    if (!store.getters.permission.masterdata_dept_query) {
      next({
        name: "err",
        params: { err: cfg.errs.NeedPromission },
      });
    } else {
      next();
    }
  },
  components: {
    "apply-editor": () => import("./editor"),
  },
  data() {
    return {
      entity: {},
      entities: {},
      meta:{
        loading: false
      },
      condition: {
        keyword: null,
        sort: "id",
        asc: false,
        pageIndexOnView: 1,
        pageSize: 20,
      },
      searchLoading: false,
      showEditor: false,
      disabledSave: false,
      //区分是否编辑状态 // 'true==>应用新增false==>应用编辑'
      between: null,
    };
  },
  computed: {
    ...mapGetters(["permission", "dict"]),
  },

  methods: {
    handleDelete(val) {
      if (val.id) {
        let _this = this;
        api.DeptRoom.del(val.id).then((res) => {
          _this.page();
          _this.$message.success("删除成功!");
        });
      }
    },
    handleEdit(val) {
      this.entity = JSON.parse(JSON.stringify(val));
      this.showEditor = true;
    },
    create() {
      this.entity = {};
      this.showEditor = true;
    },
    page() {
      let _this = this;
      this.meta.loading = true;
      api
        .DeptRoom.query(this.condition)
        .then((res) => {
          _this.entities = res;
        })
        .catch((err) => {
          if (err) {
            _this.$message.error(err.message || err);
          }
        })
        .finally(() => {
          this.meta.loading = false;
        });
    },
    sortChanged(col) {
      if (!col.order) {
        this.condition.sort = "id";
        this.condition.asc = false;
      } else {
        this.condition.sort = col.prop;
        this.condition.asc = col.order == "ascending";
      }
      this.page();
    },
    filterChanged(options) {
      Object.assign(this.condition, options);
      this.page();
    },
  },
};
</script>
